import React, { useEffect, useState, ChangeEvent} from 'react'
import Modal from 'react-bootstrap/Modal'
import { CreateUrl, CallGetAPI, CallPutAPI, CallPostAPI, CallDeleteAPI } from 'Utils/ApiHelper.js';
import { DataGrid, Column, Export, GroupPanel, Grouping, FilterRow, Pager, Paging, StateStoring, HeaderFilter, Selection, Sorting } from 'devextreme-react/data-grid';
import { Contact } from '../Alarm Functions/AlarmOverviewFunctions'
import { Button, Chip, TextField, Autocomplete } from '@mui/material';
import Loader from '../../Utils/Loader/NewLoader2025'
import { NotificationContainer, NotificationManager } from 'react-notifications';
import { FormattedMessage, IntlShape, useIntl } from 'react-intl';
import deMessages from "devextreme/localization/messages/de.json";
import frMessages from "devextreme/localization/messages/fr.json";
import esMessages from "devextreme/localization/messages/es.json";
import ptMessages from "devextreme/localization/messages/pt.json";
import { locale, loadMessages } from "devextreme/localization";

interface Props {
    show: boolean
    contactsForCompany: Contact[]
    handleAddContactsGroupToAlarm: (emailArr: string[]) => void
    handleBack: () => void
    companyId: number | null
}


interface ContactUIs {
    email: string
    added: boolean
    enabledEmail: boolean
    enabledSMS: boolean
    enabledWhatsApp: boolean
}
interface Group {
    companyId: number
    created: Date
    createdBy: string
    id: number
    name: string
    uiContacts: ContactUIs[]
}

interface APIGroup {
    companyId: number
    created: Date
    createdBy: string
    deleted: string | null
    deletedBy: string | null
    id: number
    name: string
    uiContactIds: number[]
}

const AlarmReceipientGroupModal: React.FC<Props> = ({ show, contactsForCompany, handleAddContactsGroupToAlarm, handleBack, companyId }) => {


    const intl:IntlShape = useIntl()

    const [groups, setGroups] = useState<Group[]>([])
    const [editGroup, setEditGroup] = useState<boolean>(false)
    const [tempGroup, setTempGroup] = useState<Group | undefined>()
    const [tempUser, setTempUser] = useState<string>("")
    const [loading, setLoading] = useState<boolean>(false)


    locale(sessionStorage.getItem('language') ? sessionStorage.getItem('language') : 'en-GB');
    loadMessages(frMessages);
    loadMessages(deMessages);
    loadMessages(esMessages);
    loadMessages(ptMessages);


    useEffect(() => {
        getData()
    }, [contactsForCompany])

    const iconStyle = {
        fontSize: '22px',
        cursor: 'pointer'
    }

    const btnStyle = {
        display: 'flex',
        justifyContent: 'center',
    }

    

    const getData = (): void => {
        setLoading(true)
        CallGetAPI(CreateUrl(`/api/contacts/GetContactGroupsForCompany?companyId=${companyId}`), {})
            .then(data => {
                console.log(data)
                const groupsTemp: Group[] = []
                data.forEach((d: APIGroup) => {
                    const contacts: ContactUIs[] = []
                    d.uiContactIds.forEach(con => {
                        if (contactsForCompany !== undefined && contactsForCompany.length > 0) {
                            const foundContact:Contact|undefined = contactsForCompany.find(d => d.id === con)
                            if (foundContact) {
                                contacts.push({
                                    email: foundContact.email,
                                    added: false,
                                    enabledEmail: foundContact.enabledEmail,
                                    enabledSMS: foundContact.enabledSMS,
                                    enabledWhatsApp: foundContact.enabledWhatsApp

                                })
                            } else {
                                contacts.push({
                                    email: intl.formatMessage({ id: 'Deleted Contact' }),
                                    added: false,
                                    enabledEmail: false,
                                    enabledSMS: false,
                                    enabledWhatsApp: false
                                })
                            }

                        }
                    })


                    const group: Group = {
                        id: d.id,
                        companyId: d.companyId,
                        created: d.created,
                        createdBy: d.createdBy,
                        name: d.name,
                        uiContacts: contacts
                    }

                    groupsTemp.push(group)

                })
                setGroups(groupsTemp)
                setLoading(false)
            })
            .catch(err => {
                console.error(err)
                setLoading(false)
            })
    }

    const createSuccessNotification = (): void => {
        NotificationManager.success(intl.formatMessage({ id: 'Saved Changes' }), intl.formatMessage({ id: 'Success' }));

    };

    const createErrorNotification = (): void => {
        NotificationManager.error(intl.formatMessage({ id: 'Error Saving Changes' }), intl.formatMessage({ id: 'Check console for details' }), 5000, () => {
            alert('error');
        });
    };

    const renderContacts = (data): React.ReactNode => {
        if (data.data.id === tempGroup?.id) {
            return (
                <div>
                    {data.data.uiContacts.map((d: ContactUIs, idx: number) => {
                        return (
                            <div key={idx} style={{ margin: "5px 0" }}>
                                <Chip
                                    label={d.email}
                                    color={d.added ? 'warning' : 'primary'}
                                    onDelete={(): void => handleContactRemove(d)}
                                />
                            </div>
                        )
                    })}
                    <div style={{display: 'flex', width: "100%"} }>
                        <Autocomplete
                            disablePortal
                            options={contactsForCompany.map(c => c.email).filter(d => !tempGroup?.uiContacts.map(e => e.email).includes(d))}
                            size='small'
                            sx={{ width: '100%' }}
                            renderInput={(params): React.ReactNode => <TextField {...params} label="Contacts" />}
                            onChange={(e): void => addUserViaEdit(e)}
                            disabled={contactsForCompany.map(c => c.email).filter(d => !tempGroup?.uiContacts.map(e => e.email).includes(d)).length === 0}
                        />
                        <Button
                            variant="contained"
                            onClick={(): void => handleAddUser()}
                            disabled={contactsForCompany.map(c => c.email).filter(d => !tempGroup?.uiContacts.map(e => e.email).includes(d)).length === 0}
                        >
                            <FormattedMessage id="Add" />
                        </Button>
                    </div>
                </div>
            )
            
        } else {
            return (
                <div>
                    {data.data.uiContacts.map((d: ContactUIs, idx: number) => {
                        return (
                            <div key={idx} style={{display: 'flex', width: '100%', justifyContent: 'space-between'} }>
                                <p>{d.email}</p>
                                <div style={{ display: 'flex', justifyContent: 'space-evenly', width: 100 }}>
                                    <i
                                        className="fa-solid fa-envelope"
                                        style={{ ...iconStyle, color: d.enabledEmail ? 'green' : 'gray' }}></i>
                                    {/*!window.location.hostname.includes('zonelog.net') && <i
                                        className="fas fa-sms"
                                        style={{ ...iconStyle, color: d.enabledSMS ? 'green' : 'gray' }}></i>*/}
                                    {!window.location.hostname.includes('zonelog.net') && <i
                                        className="fa-brands fa-square-whatsapp"
                                        style={{ ...iconStyle, color: d.enabledWhatsApp ? 'green' : 'gray' }}></i>}
                                </div>
                            </div>
                        )
                    })}
                </div>
            )
        }
    }
    const addUserViaEdit = (e: ChangeEvent<HTMLInputElement>) => {
        setTempUser(e.target.textContent)
    }

    const handleAddUser = ():void => {
        const g = { ...tempGroup }
        if (g.uiContacts) {
            g.uiContacts.push({ email: tempUser, added: true })
        }
        setTempGroup(g)
        setTempUser("")
        
    }

    const handleContactRemove = (d):void => {
        const groupChange:Group = { ...tempGroup }
        
        if (groupChange && groupChange.uiContacts) {
            groupChange.uiContacts = tempGroup?.uiContacts.filter(g => g !== d)
            
            const alteredData:Group[] = groups.map(g => {
                if (g.id === tempGroup.id) {
                    g.uiContacts = g.uiContacts.filter(c => c !== d)
                }
                return g
            })
            setTempGroup(groupChange)
            setGroups(alteredData)
        }
    }

    const handleGroupClick = (groupId: number):void => {
        const selectedGrp = groups.find(g => g.id === groupId)
        if (selectedGrp) {
            handleAddContactsGroupToAlarm(selectedGrp.uiContacts.map(c => c.email))
        }
    }

    const renderAddBtn = (data):React.ReactNode => {
        return (
            <div style={ btnStyle }>
                <Button variant='contained' disabled={editGroup} onClick={(): void => handleGroupClick(data.data.id)}>
                    <FormattedMessage id="Add" />
                </Button>
            </div>
        )
    }

    const renderDeleteBtn = (data, intl: IntlShape): React.ReactNode => {

        return (
            <div style={btnStyle }>
                <Button onClick={(): void => deleteClick(data.data.id, intl)} variant='contained' disabled={editGroup} color='error'>
                    <FormattedMessage id="Delete" />
                </Button>
            </div>
        )
    }

    const deleteClick = (id:number, intl:IntlShape):void => {
        const confirm = window.confirm(intl.formatMessage({ id: 'Are you sure you want to delete this Contact Group?' }))
        if (confirm) {
            CallDeleteAPI(CreateUrl(`/api/contacts/deletecontactgroup?id=${id}&deletedBy=${sessionStorage.getItem('userName')}`), {})
                .then(data => {
                    console.log(data)
                    getData()
                    createSuccessNotification()
                })
                .catch(err => {
                    console.error(err)
                    createErrorNotification()
                })
        }
    }

    const renderEditBtn = (data): React.ReactNode => {
        return (
            <div style={btnStyle}>
                <Button onClick={(): void => handleEditClick(data.data.id)} variant='contained' disabled={editGroup} color='warning'>
                    <FormattedMessage id="Edit" />
                </Button>
            </div>
        )
    }

    const handleEditClick = (id:number):void => {
        const clickedGroup = groups.find(g => g.id === id)
        setTempGroup(clickedGroup)
        toggleEditMode()
    }

    const toggleEditMode = ():void => {
        setEditGroup(!editGroup)
    }

    const renderSaveBtn = (data): React.ReactNode => {
        if (data.data.id === tempGroup?.id) {
            return (
                <div style={btnStyle}>
                    <Button onClick={(): void => handleSaveClick(data.data.id)} variant='contained' color='warning'>
                        <FormattedMessage id="Save" />
                    </Button>
                </div>
            )
        } else {
            return <div></div>
        }
    }

    const renderCancelBtn = (data): React.ReactNode => {
        if (data.data.id === tempGroup?.id) {
            return (
                <div style={btnStyle}>
                    <Button onClick={(): void => handleCancelClick(data.data.id)} variant='contained' color='error'>
                        <FormattedMessage id="Cancel" />
                    </Button>
                </div>
            )
        } else {
            return <div></div>
        }
    }

    const handleSaveClick = (): void => {
        const contactIds: number[] = []
        contactsForCompany.forEach(con => {
            if (tempGroup.uiContacts.map(c => c.email).includes(con.email)) {
                contactIds.push(con.id)
            }
        })
        const requestOptions = {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                id: tempGroup?.id,
                companyId: tempGroup?.companyId,
                name: tempGroup?.name,
                uiContactIds: contactIds,
            })
        }
        console.log(requestOptions)
        CallPutAPI(CreateUrl(`/api/contacts/editcontactgroup`), requestOptions)
            .then(data => {
                console.log(data)
                toggleEditMode()
                setTempGroup(undefined)
                createSuccessNotification()
                getData()

            })
            .catch(err => {
                console.error(err)
                createErrorNotification()
            })
    }

    const handleCancelClick = ():void => {
        setEditGroup(false)
        setTempGroup(undefined)
        setTempUser("")
        getData()
    }

    const handleNameEdit = (e:ChangeEvent<HTMLInputElement>):void => {

        const editGroup = { ...tempGroup }
        editGroup.name = e.target.value
        setTempGroup(editGroup)
    }

    const renderGroupName = (data) => {
        if (data.data.id === tempGroup?.id) {
            return (
                <div>
                    <TextField size='small' value={tempGroup?.name} onChange={(e):void => handleNameEdit(e)} />
                </div>
            )
            
        } else {
            return <p>{data.data.name}</p>
        }
    }

    const renderText = (data):React.ReactNode => {
        return <p>{data.data.createdBy}</p>
    }

    const returnToRecipients = ():void => {
        handleCancelClick()
        handleBack()
    }

    

   

    return (
        <Modal
            show={show}
            style={{
                transform:  'translate(12vw,2vh)',
                zIndex: 10000000000

            }}
            className={'modal-75w'}
        >
            <Modal.Header>
                <Modal.Title><FormattedMessage id="Recipient Groups" />
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                {loading &&
                    <div style={{   
                        display: 'flex',
                        justifyContent: 'center',
                        zIndex: 13000,
                        height: 300
                    }}>
                        <Loader color={undefined} />
                    </div>
                }
                {!loading && <DataGrid
                    dataSource={groups}
                >
                    <Column dataField='name' caption={intl.formatMessage({ id: 'Group Name' })} cellRender={(data): React.ReactNode => renderGroupName(data)} />
                    <Column dataField='createdBy' cellRender={(data): React.ReactNode => renderText(data)} caption={intl.formatMessage({id: 'Created By'})} />
                    <Column dataField='uiContactIds' cellRender={(data): React.ReactNode => renderContacts(data)} caption={intl.formatMessage({ id: 'Contacts in Group' })} width='300' />
                    {editGroup && <Column cellRender={(data): React.ReactNode => renderCancelBtn(data)} caption={intl.formatMessage({ id: "Cancel Changes" })} width='130' />}
                    {editGroup && <Column cellRender={(data): React.ReactNode => renderSaveBtn(data)} caption={intl.formatMessage({ id: "Save Changes" })} width='130' />}
                    <Column cellRender={(data): React.ReactNode => renderDeleteBtn(data, intl)} caption={intl.formatMessage({ id: "Delete Contact Group" })} width='130' />
                    <Column cellRender={(data): React.ReactNode => renderEditBtn(data)} caption={intl.formatMessage({ id: "Edit Contact Group" })} width='130' />
                    <Column cellRender={(data): React.ReactNode => renderAddBtn(data)} caption={intl.formatMessage({ id: 'Add To Alarm Contacts' })} width='130' />

                </DataGrid>}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="contained" color="error" onClick={(): void => returnToRecipients()}><FormattedMessage id="Back"/></Button>
            </Modal.Footer>
        </Modal>
    )
}

export default AlarmReceipientGroupModal